import Handlebars from "vendor/handlebars";
import hbs from "vendor/handlebars";
import Module from "global/sparta-module-utility";
import handlebarsRuntime from "vendor/handlebars-runtime";
import hb from "vendor/handlebars-runtime";
import helpersComparisons from "helpers/helpers-comparisons";
import helperComparisons from "helpers/helpers-comparisons";
import spartaRulesUtility from "global/sparta-rules-utility";
import spartaTemplates from "modules/global/semantic-markup-module/3.3.2/js/templates";





export default class semanticMarkupModule extends Module {
  constructor(options) {
    super(options);
  }





  init(args = {}) {
  }
}
